import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from '../../../services/message-service/message.service';

@Component({
  selector: 'jax-win-base',
  templateUrl: './win-base.component.html',
  styleUrls: ['./win-base.component.scss']
})
export class WinBaseComponent implements OnInit {
  protected mbValidateUser = false;
  protected msUrlWelcome = '';
  protected mbLog = false;
  constructor(
    protected router: Router,
    protected messageService: MessageService
  ) {
  }

  ngOnInit() {
    this.fnValidateUser();
    this.fnPostInit();
  }
  protected fnValidateUser() { // Se requiere usuario activo.
    if (this.mbValidateUser && !this.messageService.getIslogged() && this.msUrlWelcome !== '') {
      console.log('Navega a:', this.msUrlWelcome);
      this.router.navigate([this.msUrlWelcome]);
    }
  }
  protected fnPostInit() {

  }
}
